import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import BillingInfoView from 'views/Administration/HiredNumber/BillingInfo';
import AccountService from 'api/Account';
import AccountActions from 'store/reducers/Account';
import SettingsActions from 'store/reducers/Settings';
import { useFetch, useSubmit } from 'hooks';

const BillingInfo = ( {
  parentPath, history, locale, updateAccountInfo, toggleErrorAlert, toggleLoading,
} ) => {
  const [data, dataLoading] = useFetch( {
    initialState: {},
    promise: AccountService.getMyAccount,
    toggleErrorAlert,
  } );

  const submitForm = useSubmit( {
    promise: ( dataToSend ) => AccountService.updateAccount( data.id, dataToSend ),
    toggleLoading,
    callback: ( formData, responseData ) => {
      updateAccountInfo( responseData );
      history.push( parentPath );
    },
    deps: [data.id],
  } );

  return (
    <BillingInfoView
      data={data}
      locale={locale}
      parentPath={parentPath}
      isLoading={dataLoading}
      onSubmit={submitForm}
    />
  );
};

const mapStateToProps = ( { settings } ) => ( {
  locale: _.get( settings, 'locale.locale' ),
} );

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  toggleLoading: SettingsActions.toggleLoading,
  updateAccountInfo: AccountActions.updateInfo,
} );

export default connect( mapStateToProps, mapDispatchToProps )( BillingInfo );
